// extracted by mini-css-extract-plugin
export default {"tr":"CapacityTable_tr__VC9r8","currentZ":"CapacityTable_currentZ__bxyh2"};